(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Config — set window.AcopaChatConfig before this script loads:
  //   window.AcopaChatConfig = {
  //     backendUrl:     'https://your-server.com',
  //     agentName:      'John Boot',                              // optional
  //     avatarUrl:      'https://cdn.shopify.com/.../photo.jpg', // optional
  //     logoUrl:        'https://cdn.shopify.com/.../logo.png',  // optional fallback
  //     welcomeMessage: 'Custom welcome text'                     // optional
  //   }
  // ---------------------------------------------------------------------------
  var cfg         = window.AcopaChatConfig || {};
  var BACKEND_URL = (cfg.backendUrl || 'http://localhost:3000').replace(/\/$/, '');
  var AGENT_NAME  = cfg.agentName || 'Acopa Support';
  var AVATAR_URL  = cfg.avatarUrl || cfg.logoUrl || '';
  var WELCOME_OPTIONS = [
    "Good shoes matter. What do you need?",
    "Comfortable shoes, better climbing. What can I help you with?",
    "It starts with the right shoe. How can I help?"
  ];
  var WELCOME = cfg.welcomeMessage || WELCOME_OPTIONS[Math.floor(Math.random() * WELCOME_OPTIONS.length)];

  // ---------------------------------------------------------------------------
  // Styles
  // ---------------------------------------------------------------------------
  var CSS = [
    '#acopa-widget-toggle{',
      'position:fixed;bottom:24px;right:24px;z-index:2147483646;',
      'width:56px;height:56px;border-radius:50%;',
      'background:#F4E200;border:none;cursor:pointer;color:#1A1A1A;',
      'box-shadow:0 4px 18px rgba(0,0,0,0.25);',
      'display:flex;align-items:center;justify-content:center;',
      'transition:transform 0.18s ease,box-shadow 0.18s ease,background 0.18s ease;',
      'padding:0;outline:none;',
    '}',
    '#acopa-widget-toggle:hover{transform:scale(1.08);background:#e0d000;box-shadow:0 6px 22px rgba(0,0,0,0.3);}',
    '#acopa-widget-toggle:focus-visible{outline:3px solid #1A1A1A;outline-offset:3px;}',

    '#acopa-widget-bubble{',
      'position:fixed;bottom:92px;right:24px;z-index:2147483644;',
      'background:#1A1A1A;color:#fff;',
      'padding:9px 16px;border-radius:20px;',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-size:13px;font-weight:500;white-space:nowrap;',
      'opacity:0;transform:translateY(6px);pointer-events:none;',
      'transition:opacity 0.3s ease,transform 0.3s ease;',
    '}',
    '#acopa-widget-bubble.acopa-bubble-show{opacity:1;transform:translateY(0);}',
    '#acopa-widget-bubble::after{',
      'content:"";position:absolute;bottom:-6px;right:19px;',
      'border-left:6px solid transparent;border-right:6px solid transparent;',
      'border-top:6px solid #1A1A1A;',
    '}',

    '#acopa-widget-badge{',
      'position:absolute;top:-3px;right:-3px;',
      'width:14px;height:14px;border-radius:50%;',
      'background:#e53e3e;border:2px solid #fff;',
      'display:none;',
    '}',

    '#acopa-widget-window{',
      'position:fixed;bottom:92px;right:24px;z-index:2147483645;',
      'width:360px;height:530px;',
      'max-width:calc(100vw - 32px);max-height:calc(100vh - 110px);',
      'background:#fff;border-radius:16px;',
      'box-shadow:0 8px 36px rgba(0,0,0,0.18);',
      'display:flex;flex-direction:column;overflow:hidden;',
      'transition:opacity 0.2s ease,transform 0.2s ease;',
      'opacity:0;transform:translateY(14px) scale(0.97);pointer-events:none;',
    '}',
    '#acopa-widget-window.acopa-open{opacity:1;transform:translateY(0) scale(1);pointer-events:all;}',

    '#acopa-widget-header{',
      'background:#1A1A1A;padding:14px 16px;',
      'display:flex;align-items:center;justify-content:space-between;',
      'flex-shrink:0;',
    '}',
    '#acopa-widget-header-left{display:flex;align-items:center;gap:10px;flex:1;min-width:0;}',
    '#acopa-widget-avatar{',
      'width:38px;height:38px;border-radius:50%;',
      'background:#2e2e2e;border:1.5px solid #444;',
      'display:flex;align-items:center;justify-content:center;',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-weight:700;font-size:13px;color:#fff;flex-shrink:0;',
      'overflow:hidden;letter-spacing:0;',
    '}',
    '#acopa-widget-avatar img{width:38px;height:38px;object-fit:cover;display:block;border-radius:50%;}',
    '#acopa-widget-header-title{',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-size:14px;font-weight:600;color:#fff;',
      'white-space:nowrap;flex:1;',
    '}',
    '#acopa-widget-close{',
      'background:none;border:none;cursor:pointer;',
      'color:#666;padding:4px;border-radius:6px;',
      'display:flex;align-items:center;justify-content:center;',
      'transition:color 0.15s;outline:none;',
    '}',
    '#acopa-widget-close:hover{color:#fff;}',
    '#acopa-widget-close:focus-visible{outline:2px solid #fff;}',

    '#acopa-widget-messages{',
      'flex:1;overflow-y:auto;padding:14px 14px 6px;',
      'display:flex;flex-direction:column;gap:10px;',
      'scroll-behavior:smooth;',
    '}',
    '#acopa-widget-messages::-webkit-scrollbar{width:3px;}',
    '#acopa-widget-messages::-webkit-scrollbar-thumb{background:#ddd;border-radius:3px;}',

    '.acopa-msg{',
      'max-width:84%;padding:10px 13px;border-radius:14px;',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-size:13.5px;line-height:1.55;word-wrap:break-word;white-space:pre-wrap;',
    '}',
    '.acopa-msg-user{',
      'background:#1A1A1A;color:#fff;',
      'border-bottom-right-radius:3px;align-self:flex-end;',
    '}',
    '.acopa-msg-bot{',
      'background:#F0F0F0;color:#1A1A1A;',
      'border-bottom-left-radius:3px;align-self:flex-start;',
    '}',
    '.acopa-msg-error{',
      'background:#fff2f2;color:#b00020;',
      'border-bottom-left-radius:3px;align-self:flex-start;',
      'font-size:13px;',
    '}',

    '#acopa-widget-typing{',
      'display:none;align-self:flex-start;',
      'background:#F0F0F0;border-radius:14px;border-bottom-left-radius:3px;',
      'padding:11px 14px;gap:5px;align-items:center;',
    '}',
    '#acopa-widget-typing.acopa-show{display:flex;}',
    '.acopa-dot{',
      'width:7px;height:7px;background:#aaa;border-radius:50%;',
      'animation:acopa-bounce 1.2s ease-in-out infinite;',
    '}',
    '.acopa-dot:nth-child(2){animation-delay:0.18s;}',
    '.acopa-dot:nth-child(3){animation-delay:0.36s;}',
    '@keyframes acopa-bounce{0%,60%,100%{transform:translateY(0);}30%{transform:translateY(-6px);}}',

    '#acopa-widget-input-row{',
      'border-top:1px solid #ebebeb;padding:10px 12px;',
      'background:#fff;display:flex;gap:8px;align-items:flex-end;flex-shrink:0;',
    '}',
    '#acopa-widget-input{',
      'flex:1;border:1.5px solid #ddd;border-radius:10px;',
      'padding:9px 12px;',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-size:13.5px;line-height:1.45;',
      'resize:none;outline:none;max-height:96px;overflow-y:auto;',
      'color:#1A1A1A;background:#fff;',
      'transition:border-color 0.15s;',
    '}',
    '#acopa-widget-input:focus{border-color:#1A1A1A;}',
    '#acopa-widget-input::placeholder{color:#bbb;}',
    '#acopa-widget-input:disabled{background:#fafafa;color:#aaa;}',
    '#acopa-widget-send{',
      'width:38px;height:38px;flex-shrink:0;',
      'background:#F4E200;border:none;border-radius:10px;cursor:pointer;',
      'color:#1A1A1A;',
      'display:flex;align-items:center;justify-content:center;',
      'transition:background 0.15s,transform 0.1s;outline:none;',
    '}',
    '#acopa-widget-send:hover{background:#e0d000;}',
    '#acopa-widget-send:active{transform:scale(0.93);}',
    '#acopa-widget-send:disabled{background:#888;cursor:not-allowed;}',
    '#acopa-widget-send:focus-visible{outline:2px solid #1A1A1A;outline-offset:2px;}',

    '#acopa-widget-footer{',
      'display:flex;align-items:center;justify-content:space-between;',
      'padding:6px 14px 10px;flex-shrink:0;',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-size:10.5px;color:#ccc;',
    '}',
    '#acopa-widget-footer a{color:#ccc;text-decoration:none;}',
    '#acopa-widget-footer a:hover{color:#666;}',
    '#acopa-widget-human-btn{',
      'background:none;border:1px solid #e0e0e0;border-radius:6px;',
      'padding:3px 8px;cursor:pointer;',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'font-size:10.5px;color:#888;',
      'transition:border-color 0.15s,color 0.15s;white-space:nowrap;',
    '}',
    '#acopa-widget-human-btn:hover{border-color:#1A1A1A;color:#1A1A1A;}',

    '@media(max-width:480px){',
      '#acopa-widget-window{',
        'right:0;left:0;bottom:0;',
        'width:100%;max-width:100%;',
        'height:100vh;height:100dvh;',
        'max-height:100%;border-radius:0;',
      '}',
      '#acopa-widget-toggle{bottom:16px;right:16px;}',
      '#acopa-widget-toggle.acopa-chat-open{display:none;}',
      '#acopa-widget-header{padding:12px 14px;}',
      '#acopa-widget-header-left{flex:1;min-width:0;display:flex;align-items:center;gap:10px;}',
      '#acopa-widget-avatar{width:34px;height:34px;flex-shrink:0;}',
      '#acopa-widget-avatar img{width:34px;height:34px;}',
      '#acopa-widget-header-title{flex:1;font-size:14px;color:#fff;font-weight:600;white-space:nowrap;}',
      '#acopa-widget-messages{padding:12px 12px 4px;}',
      '.acopa-msg{font-size:13px;}',
      '#acopa-widget-input-row{',
        'padding:8px 10px;',
        'padding-bottom:max(8px,env(safe-area-inset-bottom));',
      '}',
      '#acopa-widget-input{font-size:16px;}',
    '}'
  ].join('');

  // ---------------------------------------------------------------------------
  // SVG icons  (white strokes — sit on black backgrounds)
  // ---------------------------------------------------------------------------
  var ICON_CHAT      = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  var ICON_CLOSE_BTN = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_SEND      = '<span style="font-size:17px;line-height:1;color:#1A1A1A;display:flex;align-items:center;justify-content:center;">&#10148;</span>';

  // ---------------------------------------------------------------------------
  // State
  // ---------------------------------------------------------------------------
  var isOpen = false;
  var isLoading = false;
  var conversationHistory = [];

  // Persist session across page refreshes via localStorage
  var SESSION_ID = (function () {
    try {
      var stored = localStorage.getItem('acopa_session_id');
      if (stored) return stored;
      var id = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem('acopa_session_id', id);
      return id;
    } catch (e) {
      return 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    }
  }());

  // ---------------------------------------------------------------------------
  // DOM refs (set after build)
  // ---------------------------------------------------------------------------
  var toggleBtn, window_, messagesEl, typingEl, inputEl, sendBtn, bubbleEl;

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------
  function injectCSS() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function escapeHTML(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildAvatarHTML() {
    if (AVATAR_URL) {
      return '<img src="' + escapeHTML(AVATAR_URL) + '" alt="' + escapeHTML(AGENT_NAME) + '" />';
    }
    return AGENT_NAME.substring(0, 2).toUpperCase();
  }

  function appendMessage(text, type) {
    var div = document.createElement('div');
    div.className = 'acopa-msg acopa-msg-' + type;
    div.textContent = text;
    messagesEl.insertBefore(div, typingEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function setLoading(val) {
    isLoading = val;
    sendBtn.disabled = val;
    inputEl.disabled = val;
    if (val) {
      typingEl.classList.add('acopa-show');
      messagesEl.scrollTop = messagesEl.scrollHeight;
    } else {
      typingEl.classList.remove('acopa-show');
    }
  }

  function autoResize() {
    inputEl.style.height = 'auto';
    inputEl.style.height = Math.min(inputEl.scrollHeight, 96) + 'px';
  }

  // ---------------------------------------------------------------------------
  // Load previous conversation from Supabase (via backend)
  // ---------------------------------------------------------------------------
  function loadHistory() {
    fetch(BACKEND_URL + '/api/history/' + SESSION_ID)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var msgs = data.messages || [];
        if (!msgs.length) return;
        msgs.forEach(function (m) {
          var type = m.role === 'user' ? 'user' : 'bot';
          appendMessage(m.message, type);
          conversationHistory.push({ role: m.role, content: m.message });
        });
      })
      .catch(function () { /* history unavailable — start fresh */ });
  }

  // ---------------------------------------------------------------------------
  // Open / close
  // ---------------------------------------------------------------------------
  function openChat() {
    isOpen = true;
    window_.classList.add('acopa-open');
    window_.setAttribute('aria-hidden', 'false');
    toggleBtn.classList.add('acopa-chat-open');
    toggleBtn.setAttribute('aria-label', 'Close support chat');
    toggleBtn.innerHTML = ICON_CLOSE_BTN + '<span id="acopa-widget-badge"></span>';
    if (bubbleEl) bubbleEl.classList.remove('acopa-bubble-show');
    setTimeout(function () { inputEl && inputEl.focus(); }, 220);
  }

  function closeChat() {
    isOpen = false;
    window_.classList.remove('acopa-open');
    window_.setAttribute('aria-hidden', 'true');
    toggleBtn.classList.remove('acopa-chat-open');
    toggleBtn.setAttribute('aria-label', 'Open support chat');
    toggleBtn.innerHTML = ICON_CHAT + '<span id="acopa-widget-badge"></span>';
  }

  // ---------------------------------------------------------------------------
  // Send message
  // ---------------------------------------------------------------------------
  function sendMessage() {
    var message = inputEl.value.trim();
    if (!message || isLoading) return;

    inputEl.value = '';
    inputEl.style.height = 'auto';
    appendMessage(message, 'user');
    setLoading(true);

    var payload = JSON.stringify({ message: message, conversationHistory: conversationHistory, sessionId: SESSION_ID });

    fetch(BACKEND_URL + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'Request failed');
          return data;
        });
      })
      .then(function (data) {
        conversationHistory.push({ role: 'user', content: message });
        conversationHistory.push({ role: 'assistant', content: data.reply });
        appendMessage(data.reply, 'bot');
      })
      .catch(function () {
        appendMessage('Something went wrong. Please try again or email info@acopaoutdoors.com.', 'error');
      })
      .finally(function () {
        setLoading(false);
        inputEl.focus();
      });
  }

  // ---------------------------------------------------------------------------
  // Build DOM
  // ---------------------------------------------------------------------------
  function buildWidget() {
    var mount = document.getElementById('acopa-chat-widget');
    if (!mount) return;

    // Toggle button
    toggleBtn = document.createElement('button');
    toggleBtn.id = 'acopa-widget-toggle';
    toggleBtn.setAttribute('aria-label', 'Open support chat');
    toggleBtn.setAttribute('aria-haspopup', 'dialog');
    toggleBtn.innerHTML = ICON_CHAT + '<span id="acopa-widget-badge"></span>';

    // Chat window
    window_ = document.createElement('div');
    window_.id = 'acopa-widget-window';
    window_.setAttribute('role', 'dialog');
    window_.setAttribute('aria-label', 'Acopa support chat');
    window_.setAttribute('aria-hidden', 'true');
    window_.innerHTML = [
      '<div id="acopa-widget-header">',
        '<div id="acopa-widget-header-left">',
          '<div id="acopa-widget-avatar">' + buildAvatarHTML() + '</div>',
          '<div id="acopa-widget-header-title">' + escapeHTML(AGENT_NAME) + '</div>',
        '</div>',
        '<button id="acopa-widget-close" aria-label="Close chat">' + ICON_CLOSE_BTN + '</button>',
      '</div>',
      '<div id="acopa-widget-messages">',
        '<div class="acopa-msg acopa-msg-bot">' + escapeHTML(WELCOME) + '</div>',
        '<div id="acopa-widget-typing">',
          '<span class="acopa-dot"></span>',
          '<span class="acopa-dot"></span>',
          '<span class="acopa-dot"></span>',
        '</div>',
      '</div>',
      '<div id="acopa-widget-input-row">',
        '<textarea id="acopa-widget-input" rows="1" placeholder="Ask about sizing, models, orders…" aria-label="Your message"></textarea>',
        '<button id="acopa-widget-send" aria-label="Send message">' + ICON_SEND + '</button>',
      '</div>',
      '<div id="acopa-widget-footer">',
        '<span>Powered by Acopa AI</span>',
        '<a id="acopa-widget-human-btn" href="mailto:info@acopaoutdoors.com?subject=Support%20request" title="Email our team">Talk to a person</a>',
      '</div>'
    ].join('');

    // Speech bubble
    bubbleEl = document.createElement('div');
    bubbleEl.id = 'acopa-widget-bubble';
    bubbleEl.textContent = 'Ask me anything';
    document.body.appendChild(bubbleEl);

    document.body.appendChild(toggleBtn);
    document.body.appendChild(window_);

    // Show bubble after 3s, auto-dismiss after 5s
    setTimeout(function () {
      if (!isOpen) {
        bubbleEl.classList.add('acopa-bubble-show');
        setTimeout(function () { bubbleEl.classList.remove('acopa-bubble-show'); }, 5000);
      }
    }, 3000);

    // Cache refs
    messagesEl = document.getElementById('acopa-widget-messages');
    typingEl   = document.getElementById('acopa-widget-typing');
    inputEl    = document.getElementById('acopa-widget-input');
    sendBtn    = document.getElementById('acopa-widget-send');

    // Events
    toggleBtn.addEventListener('click', function () { isOpen ? closeChat() : openChat(); });
    document.getElementById('acopa-widget-close').addEventListener('click', closeChat);
    sendBtn.addEventListener('click', sendMessage);
    inputEl.addEventListener('input', autoResize);
    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeChat();
    });

    // Load previous messages if this session has history
    loadHistory();
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------
  injectCSS();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildWidget);
  } else {
    buildWidget();
  }

})();
